import { render, staticRenderFns } from "./StripePayPayment.vue?vue&type=template&id=039f12c2&scoped=true&"
import script from "./StripePayPayment.vue?vue&type=script&lang=js&"
export * from "./StripePayPayment.vue?vue&type=script&lang=js&"
import style0 from "./StripePayPayment.vue?vue&type=style&index=0&id=039f12c2&prod&scoped=true&lang=scss&"
import style1 from "./StripePayPayment.vue?vue&type=style&index=1&id=039f12c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f12c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow})
